import { cn } from "@/lib/utils"
import { Button } from "@/components/ui-kit/button"
import { ArrowLeftIcon } from "@/components/icons"
import { PaymentMethodIcons } from "@/components/payments/payment-method-icons"

type RentStepButtonsProps = {
  isLastStep: boolean
  isFirstStep?: boolean
  isNextDisabled: boolean
  onNext: () => void
  onBack: () => void
  fixed?: boolean
}

export function RentStepButtons({
  isLastStep,
  isFirstStep = false,
  isNextDisabled,
  onNext,
  onBack,
  fixed = false,
}: RentStepButtonsProps) {
  return (
    <div
      className={cn(
        "flex min-w-0 bg-background lg:bg-transparent isolate [transform:translateZ(0)]",
        fixed
          ? "fixed inset-x-0 bottom-0 z-50 p-2 lg:border-t lg:border-border lg:p-4"
          : "absolute bottom-8 left-8 right-8 w-[calc(100%-64px)]",
      )}
    >
      {!isFirstStep && (
        <Button
          variant="secondary"
          className="mr-1 w-auto shrink-0 flex-none justify-start bg-muted px-4 backface-hidden lg:flex-[25%] lg:justify-between lg:px-5 lg:h-[60px] h-[48px]"
          onClick={onBack}
          startIcon={<ArrowLeftIcon size={24} className="size-6" />}
          endIcon={false}
        >
          Назад
        </Button>
      )}
      <Button
        variant="primary"
        className={cn(
          "min-w-0 flex-1 justify-between backface-hidden lg:flex-[75%] lg:h-[60px] h-[48px]",
          isFirstStep && "w-full",
        )}
        disabled={isNextDisabled}
        onClick={onNext}
        endIcon={isLastStep ? <PaymentMethodIcons /> : undefined}
      >
        {isLastStep ? "Оплатить" : "Далее"}
      </Button>
    </div>
  )
}
